import React, { useState } from 'react';
import { Radio } from 'antd';
import { I18n } from '@aws-amplify/core';
import { ExpandIcon } from '@/assets/icons';
import FormItem from '@/components/ui/FormItem';

import { PostureDisplayCard, PostureDisplayModal } from '@/components/views/Report/KimLhc/Components/Shared/PostureDisplay';
import { POSTURE_OPTIONS, type PostureOption } from './BodyPostureOptions';
import * as S from './styles';

interface BodyPostureFormItemProps {
	fieldName?: string | string[];
	required?: boolean;
}

export function BodyPostureFormItem({ required = true, fieldName }: Readonly<BodyPostureFormItemProps>): JSX.Element {
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedPosture, setSelectedPosture] = useState<PostureOption | null>(null);

	const handleExpandClick = (posture: PostureOption, e: React.MouseEvent) => {
		e.stopPropagation();
		setSelectedPosture(posture);
		setModalOpen(true);
	};

	return (
		<>
			<FormItem
				name={fieldName}
				required={required}
				requiredMessage={I18n.get('The field requires an answer')}
				style={{ marginBottom: 0 }}
			>
				<Radio.Group style={{ width: '100%', height: '100%' }}>
					<S.PostureGrid>
						{POSTURE_OPTIONS.map((option) => (
							<S.PostureCard key={option.id}>
								<Radio value={option.id} style={{ width: '100%', height: '100%' }}>
									<S.PostureCardContent>
										<PostureDisplayCard
											startLabel={option.startLabel}
											endLabel={option.endLabel}
											startImages={option.startImages}
											endImages={option.endImages}
										/>
										<S.ExpandButton
											type="text"
											icon={<ExpandIcon width={16} height={16} />}
											onClick={(e) => handleExpandClick(option, e)}
										/>
									</S.PostureCardContent>
								</Radio>
							</S.PostureCard>
						))}
					</S.PostureGrid>
				</Radio.Group>
			</FormItem>

			<S.StyledModal
				open={modalOpen}
				onCancel={() => setModalOpen(false)}
				footer={null}
				width={700}
				centered
				title={I18n.get('Body posture')}
			>
				{selectedPosture && (
					<S.ModalContent>
						<PostureDisplayModal
							startLabel={selectedPosture.startLabel}
							endLabel={selectedPosture.endLabel}
							startImages={selectedPosture.startImages}
							endImages={selectedPosture.endImages}
						/>
					</S.ModalContent>
				)}
			</S.StyledModal>
		</>
	);
}
